import React, {useContext, useState, useEffect} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import store from '../../redux';
import { authenticationService } from '../../services/authenticationService';
import Clock from 'react-live-clock';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  UploadOutlined,
  InboxOutlined,
  DeleteOutlined,
  CameraOutlined,
} from '@ant-design/icons';
import Icon from '@ant-design/icons';
import {Menu, Typography, Image, Form, PageHeader, Layout, Avatar, Modal, Upload, message, Button, Dropdown} from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import './index.css';
import {Context} from "../../context";
import users from "../../services/users";
import { useI18n } from '../../i18n';
import getBaseUrl from "../../helpers/getBaseUrl";
import ttcLogo from '../../assets/images/ttc.png';

const { SubMenu } = Menu;
const { Text } = Typography;
const { Dragger } = Upload;

const getMediaUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('data:') || path.startsWith('blob:') || path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  let base = getBaseUrl() || '';
  if (typeof window !== 'undefined' && window.location?.port === '3000') {
    base = 'http://localhost:8000';
  }
  return base.replace(/\/+$/, '') + (path.startsWith('/') ? path : '/' + path);
};

function HeaderNav({
  temperature,
  icon,
  collapsed,
  onCollapse,
  signOut,
  history,
  userData,
}) {
  const { lang, setLang, t } = useI18n();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  let timezon = 'Asia/Almaty';

  const { toNotify } = useContext(Context);
  if (userData?.profile?.branch?.timezon === 1) {
    timezon = 'Asia/Oral';
  } else if (userData?.profile?.branch?.timezon === 2) {
    timezon = 'Asia/Almaty';
  }

  const showModal = () => {
    setFileList([]);
    setPreviewUrl(userData?.profile?.photo || null);
    setIsModalVisible(true);
  };

  const handleCancel = (e) => {
    if (e) {
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.preventDefault === 'function') e.preventDefault();
    }
    setFileList([]);
    setPreviewUrl(null);
    setIsModalVisible(false);
    try {
      document.body.style.overflow = '';
      document.body.classList.remove('ant-scrolling-effect');
    } catch (err) {}
  };

  const uploadProps = {
    name: 'photo',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      const isAccepted = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type);
      if (!isAccepted) {
        toNotify('warning', t('common.warning', 'Предупреждение'), t('header.photo_format_warning', 'Файл должен быть в JPG, PNG или WebP формате!'));
        return Upload.LIST_IGNORE;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        toNotify('warning', t('common.warning', 'Предупреждение'), 'Размер файла не должен превышать 10MB!');
        return Upload.LIST_IGNORE;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);

      setFileList([file]);
      return false;
    },
    fileList,
    maxCount: 1,
    accept: 'image/png, image/jpeg, image/jpg, image/webp',
  };

  const handleRemoveSelected = (e) => {
    if (e) e.stopPropagation();
    setFileList([]);
    setPreviewUrl(userData?.profile?.photo || null);
  };

  const onFinish = () => {
    if (fileList.length === 0) {
      toNotify('warning', t('common.warning', 'Предупреждение'), t('header.choose_photo', 'Выберите фото'));
      return;
    }

    const currentUserId = userData?.id || localStorage.getItem('userId');
    if (!currentUserId) {
      toNotify('error', t('common.error', 'Ошибка'), 'Не удалось определить пользователя');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    const rawFile = fileList[0]?.originFileObj || fileList[0];
    formData.append('photo', rawFile);

    users.updatePhotoUser(currentUserId, formData)
      .then((response) => {
        toNotify('success', t('common.success', 'Успешно'), t('header.photo_updated', 'Фото успешно обновлено!'));
        setIsModalVisible(false);
        setFileList([]);
        setPreviewUrl(null);

        if (response?.data?.profile) {
          localStorage.setItem('userData', JSON.stringify(response.data));
          if (response.data?.profile?.role) {
            localStorage.setItem('userRole', JSON.stringify(response.data.profile.role));
          }
          store.dispatch({ type: 'SAVE_USER_DATA', payload: response.data });
        }

        return users.getUserById(currentUserId).then((userResp) => {
          if (userResp?.data) {
            localStorage.setItem('userData', JSON.stringify(userResp.data));
            if (userResp.data?.profile?.role) {
              localStorage.setItem('userRole', JSON.stringify(userResp.data.profile.role));
            }
            store.dispatch({ type: 'SAVE_USER_DATA', payload: userResp.data });
          }
        });
      })
      .catch((error) => {
        console.error('Photo upload error:', error);
        toNotify('error', t('common.error', 'Ошибка'), error?.response?.data?.detail || error?.response?.data?.error || 'Не удалось загрузить фото');
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const handleLangChange = ({ key }) => {
    setLang(key);
    setLangOpen(false);
  };

  const languageMenu = (
    <Menu selectedKeys={[lang]} onClick={handleLangChange} className='header-lang-dropdown-menu'>
      <Menu.Item key='kz' className='header-lang-menu-item'>
        <div className='lang-menu-item-content'>
          <span className='lang-item-badge'>KZ</span>
          <span className='lang-item-text'>Қазақша</span>
        </div>
      </Menu.Item>
      <Menu.Item key='ru' className='header-lang-menu-item'>
        <div className='lang-menu-item-content'>
          <span className='lang-item-badge'>RU</span>
          <span className='lang-item-text'>Русский</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const userMenu = (
    <Menu className='header-user-dropdown-menu'>
      <Menu.Item
        key='profile'
        className='header-user-menu-item'
        onClick={() => {
          setUserOpen(false);
          showModal();
        }}
      >
        <div className='user-menu-item-content'>
          <span className='user-item-icon-badge'><UserOutlined /></span>
          <span className='user-item-text'>{t('header.edit_photo', 'Изменить фото')}</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key='logout'
        className='header-user-menu-item'
        onClick={() => {
          authenticationService.logout();
          signOut();
          history.push('/');
        }}
      >
        <div className='user-menu-item-content'>
          <span className='user-item-icon-badge'><LogoutOutlined /></span>
          <span className='user-item-text'>{t('header.logout', 'Выйти из системы')}</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const selectedFile = fileList.length > 0 ? fileList[0] : null;

  return (
    <>
      {isModalVisible && (
        <Modal
          key='edit-user-photo-modal'
          title={
            <div className='photo-modal-header-title'>
              <CameraOutlined className='photo-modal-title-icon' />
              <span>{t('header.edit_photo', 'Изменить фото')}</span>
            </div>
          }
          visible={true}
          onCancel={handleCancel}
          footer={null}
          destroyOnClose={true}
          centered
          width={420}
          maskClosable={true}
          keyboard={true}
          closable={true}
          className='custom-photo-upload-modal'
        >
          <div className='photo-modal-content'>
            {/* Circular Avatar Preview */}
            <div className='photo-preview-section'>
              <div className='photo-preview-avatar-wrap'>
                <Avatar
                  size={90}
                  src={getMediaUrl(previewUrl)}
                  icon={!previewUrl && <UserOutlined style={{ fontSize: 44 }} />}
                  className='photo-preview-avatar'
                />
                {previewUrl && (
                  <div className='photo-avatar-badge' title='Предпросмотр'>
                    <CameraOutlined />
                  </div>
                )}
              </div>
              <div className='photo-preview-user-info'>
                <div className='photo-user-full-name'>
                  {((userData?.profile?.first_name || '') + ' ' + (userData?.profile?.last_name || '')).trim() || userData?.email || 'Пользователь'}
                </div>
                <div className='photo-user-subtext'>
                  {userData?.profile?.role?.name || userData?.email || ''}
                </div>
              </div>
            </div>

            {/* Dragger Zone */}
            <div className='photo-upload-dragger-wrap'>
              <Dragger {...uploadProps} className='photo-custom-dragger'>
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined style={{ color: '#52c41a', fontSize: 36 }} />
                </p>
                <p className='ant-upload-text'>
                  {lang === 'kz' ? 'Суретті осында сүйреңіз немесе басыңыз' : 'Нажмите или перетащите фото сюда'}
                </p>
                <p className='ant-upload-hint'>
                  {lang === 'kz' ? 'JPG, PNG, WebP (10 МБ дейін)' : 'JPG, PNG, WebP (до 10 МБ)'}
                </p>
              </Dragger>
            </div>

            {/* Selected File Card */}
            {selectedFile && (
              <div className='selected-file-card'>
                <div className='selected-file-info'>
                  <span className='selected-file-icon'>📷</span>
                  <div className='selected-file-details'>
                    <span className='selected-file-name'>{selectedFile.name}</span>
                    <span className='selected-file-size'>
                      {(selectedFile.size / 1024).toFixed(1)} KB
                    </span>
                  </div>
                </div>
                <Button
                  type='text'
                  danger
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={handleRemoveSelected}
                  className='selected-file-remove-btn'
                />
              </div>
            )}

            {/* Footer Actions */}
            <div className='photo-modal-footer'>
              <Button
                className='photo-modal-cancel-btn'
                onClick={handleCancel}
                disabled={uploading}
              >
                {t('common.cancel', 'Отмена')}
              </Button>
              <Button
                type='primary'
                className='photo-modal-save-btn'
                onClick={onFinish}
                loading={uploading}
                disabled={fileList.length === 0}
              >
                {t('common.save', 'Сохранить')}
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <header className='app-header'>
        <div className='app-header-left'>
          <button
            type='button'
            className='app-header-btn app-header-trigger'
            onClick={() => onCollapse(!collapsed)}
            aria-label='Меню'
          >
            {collapsed ? (
              <MenuUnfoldOutlined />
            ) : (
              <MenuFoldOutlined />
            )}
          </button>
        </div>

        <div className='app-header-center'>
          <img src={ttcLogo} alt='TTC' className='app-header-logo' />
        </div>

        <div className='app-header-right'>
          {/* Время */}
          <div className='app-header-badge app-header-clock'>
            <Clock
              key='current'
              className='clock-text'
              format={'HH:mm:ss'}
              ticking={true}
              timezone={timezon}
            />
          </div>

          {/* Погода */}
          <div className='app-header-badge app-header-weather'>
            {temperature != null && !isNaN(temperature) && (icon?.rawIcon || icon?.icon) ? (
              <>
                <img
                  key='icon'
                  className='weather-icon-img'
                  alt='weather'
                  src={`https://openweathermap.org/img/wn/${icon?.rawIcon || '01d'}.png`}
                />
                <span className='weather-temp'>{`${temperature}°`}</span>
              </>
            ) : (
              <span className='weather-placeholder'>--°</span>
            )}
          </div>

          {/* Язык */}
          <Dropdown
            overlay={languageMenu}
            placement='bottomRight'
            visible={langOpen}
            onVisibleChange={(vis) => {
              setLangOpen(vis);
              if (vis) setUserOpen(false);
            }}
          >
            <button type='button' className='app-header-btn app-header-lang-btn' aria-label='Язык'>
              <span>{lang === 'kz' ? 'KZ' : 'RU'}</span>
            </button>
          </Dropdown>

          {/* Пользователь */}
          <Dropdown
            overlay={userMenu}
            placement='bottomRight'
            visible={userOpen}
            onVisibleChange={(vis) => {
              setUserOpen(vis);
              if (vis) setLangOpen(false);
            }}
          >
            <button type='button' className='app-header-btn app-header-user-btn' aria-label='Профиль'>
              <Avatar
                size={30}
                src={getMediaUrl(userData?.profile?.photo)}
                icon={!userData?.profile?.photo && <UserOutlined />}
                className='app-header-avatar'
              />
              <span className='app-header-username'>
                {((userData?.profile?.first_name || '') + ' ' + (userData?.profile?.last_name || '')).trim() || userData?.email || 'Администратор'}
              </span>
            </button>
          </Dropdown>
        </div>
      </header>
    </>
  );
}

function mapStateToProps(state) {
  return {
    userData: state.user.userData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signOut: () => dispatch({ type: 'SIGN_OUT' }),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderNav)
);
